module.exports = __webpack_public_path__ + "img/militarnyi.a24acde0.svg";